export const FETCH_POSTS_FAILS = "FETCH_POSTS_FAILS";
export const FETCH_POSTS = "FETCH_POSTS";
export const ADD = "ADD";
export const DELETE_POST = "DELETE_POST";
export const SELECTED_POST_ID = "SELECTED_POST_ID";
export const LOAD_POST_DESCRIPTION = "LOAD_POST_DESCRIPTION";
export const ADD_POST = "ADD_POST";
export const CANCEL_POST = "CANCEL_POST";
export const SUBMIT_POST = "SUBMIT_POST";
export const EDIT_POST = "EDIT_POST";
export const LOAD_LARGE_IMAGE = "LOAD_LARGE_IMAGE";
export const BACKDROP_CLICKED = "BACKDROP_CLICKED";
export const PREVIOUS_CLICKED = "PREVIOUS_CLICKED";
export const NEXT_CLICKED = "NEXT_CLICKED";
export const FETCH_USERS = "FETCH_USERS";
export const FETCH_USER = "FETCH_USER";

export const FETCH_USERS_FAILED = "FETCH_USERS_FAILED";
export const FETCH_SELECTED_USER = "FETCH_SELECTED_USER";
export const CAL_BUTTON_GROUP = "CAL_BUTTON_GROUP";

export const ADD_CTR = "ADD_CTR";
export const SUBTRACT_CTR = "SUBTRACT_CTR";
export const ADD10 = "ADD10";
export const SUBTRACT10 = "SUBTRACT10";

export const STORE_COUNTER = "STORE_COUNTER";
export const CANCEL_ADDPOST = "CANCEL_ADDPOST";
export const DELETE_RESULT = "DELETE_RESULT";
export const ADD_PERSON = "ADD_PERSON";
export const DELETE_ROW = "DELETE_ROW";

//Article Actions
export const FETCH_ARTICLES = "FETCH_ARTICLES";
export const FETCH_ARTICLES_FAIL = "FETCH_ARTICLES_FAIL";
export const EDIT_ARTICLE_DESCRIPTION = "EDIT_ARTICLE_DESCRIPTION";
export const SAVE_EDIT_BUTTON = "SAVE_EDIT_BUTTON";
export const DELETE_ARTICLE = "DELETE_ARTICLE";

export const LOADER = "LOADER";

//Photos Actions
export const FETCH_PHOTOS = "FETCH_PHOTOS";

// Jotto App - Guess Word
export const CHECK_WORD = "CHECK_WORD";
export const UPDATE_GUESSWORD = "UPDATE_GUESSWORD";
export const CORRECT_GUESS = "CORRECT_GUESS ";
export const GUESS_WORD = "GUESS_WORD";
